<!--
 * @Author: lan.h
 * @Date: 2022-02-21 14:39:12
 * @LastEditors: lan.h
 * @LastEditTime: 2022-03-28 11:11:03
 * @Description: 最新融资
-->
<template>
  <div class="latest" v-if="latest_list.length > 0">
    <div class="mode-title">
      <span class="title-p">最新融资</span>
      <div class="comp-src-name">融资数据由 <img :src="$store.state.static_img_url+'pic/logo.png'" alt="动脉橙"  @click="haddleApplyTry2(32)"> 提供支持</div>
    </div>
    <ul>
      <li v-for="item, index in latest_list" :key="index">
        <div class="logo">
          <img :src="item.logo | logo_show">
        </div>
        <div class="li-content">
          <div>
            <div class="left">
              <p class="over-p1" @click="toEntity(item)">{{item.shortName}}</p>
              <span class="follow" v-if="!item.subscribe" @click="haddleSubscribe(item, index)">关注</span>
              <span class="follow on" v-if="item.subscribe" @click="haddleCancel(item, index)">已关注</span>
            </div>
            <div class="right">
              <span v-if="item.roundId">{{item.roundId | deal('round', 'name', '')}}</span>
              {{item.amount | amountPrecise(item.unitId, item.precise)}}
            </div>
          </div>
          <div>
            <p class="over-p1">{{item.entityDes}}</p>
            <span>{{item.eventTime | time_standard}}</span>
          </div>
        </div>
      </li>
    </ul>
    <div class="flash-more" @click="toEventList()">
      <a>查看更多</a>
    </div>
  </div>
</template>

<script>
import { entityEvent } from "../../service";
import { atten_common } from 'js/atten_common'
export default {
  mixins: [ atten_common ], 
  inject: ["login" , 'haddleApplyTry2'],
  props: {
    size: { //数量
      default: 3
    },
    pageType: {
      default: ''    //1首页  2文章详情
    }
  },
  data() {
    return {
      latest_list: [],
      loading: false,
    }
  },
  computed: {
    user_key() {
      return this.$store.state.user_key
    }
  },
  created() {
    this.getList()
  },
  methods: {
    toEntity(a) {
      const href = this.$store.state.index_path + '/companyDetail/' + a.entityUid
      window.open(href, '_blank')
      if(this.pageType == '1'){
        _czc.push(['_trackEvent', '首页(新)', '右侧最新融资栏(公司)', '点击量'])
      }
      else if(this.pageType == '2'){
        _czc.push(['_trackEvent', '文章详细页(新)', '右侧(最新融资_公司)', '点击量'])
      }
    },
    haddleSubscribe(item, index) {
      if (this.user_key) {
        const cb = () => {
          this.latest_list[index].subscribe = true
          this.subscribeSuccess()
        }
        this.addSubscribe(0, item.entityId, cb)
      } else {
        this.login()
      }
      if(this.pageType == '1'){
        _czc.push(['_trackEvent', '首页(新)', '右侧最新融资栏(公司关注/取消)', '点击量'])
      }
      else if(this.pageType == '2'){
        _czc.push(['_trackEvent', '文章详细页(新)', '右侧(最新融资_关注/取消)', '点击量'])
      }
    },
    toEventList() {
      const href = this.$store.state.index_path + '/eventList'
      window.open(href, '_blank')
      if(this.pageType == '1'){
        _czc.push(['_trackEvent', '首页(新)', '右侧最新融资栏(查看更多)', '点击量'])
      }
      else if(this.pageType == '2'){
        _czc.push(['_trackEvent', '文章详细页(新)', '右侧(最新融资_查看更多)', '点击量'])
      }
    },
    haddleCancel(item, index) {
      if (this.user_key) {
        let i = this.$store.state.attention.subscribe.findIndex(a => a.sub_type_id == item.entityId)
        if(i > -1) {
          const cb = () => {
            this.latest_list[index].subscribe = false
            this.cancelSuccess()
          }
          this.deleteSubscribe(this.$store.state.attention.subscribe[i]['id'], cb)
        }
      } else {
        this.login()
      }
    },
    async getList() {
      this.loading = true
      let res = await entityEvent( {
        userKey: this.$store.state.user_key,
        page: 1,
        size: this.size
      }, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.code == 0) {
        this.$set(this.$data, 'latest_list', res.data.entityEventInfos)
        this.loading = false
      } else {
        this.$Message.error(res.msg)
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.latest
  ul 
    li 
      margin-top 20px
      display flex
      justify-content space-between
      align-items: center
      .m5 
        margin-left 5px
      .m10
        margin-left 10px
      .logo
        width 40px
        height 40px
        display flex 
        justify-content center
        align-items center
        border 1px solid #F5F5F5
        img 
          max-width 100% 
          max-height 100%
      .li-content
        width calc(100% - 45px)
        >div:nth-child(1)
          display flex 
          justify-content space-between
          color #333333
          font-size 14px
          line-height 1
          .left 
            display flex
            p 
              color #333333
              cursor pointer
              line-height: 22px
              max-width: 80px
              &:hover
                color #FF6600
            .follow
              color #FF8824
              cursor pointer
              height: 22px;
              background: #FFF8F1;
              border-radius: 4px;
              display flex
              padding 0 8px
              align-items: center   
              font-size: 12px   
              margin-left 8px
              transition all .5s
              -webkit-transition all .5s
              &.on
              &:hover
                background #FF6600
                color #fff
          .right
            font-size: 14px
            line-height: 22px
        >div:nth-child(2)
          font-size 12px
          font-weight 500
          color #999999
          line-height 1
          display flex 
          justify-content space-between
          margin-top 6px
          p 
            flex 1
  .flash-more
    margin-top 20px
</style>